import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

// Components
import LazyImage from 'dibs-react-lazy-image';

// Styles
import styles from './SbMobileNullSearchResults.scss';

// constants
import { VERTICAL_OFFSET_MOBILE_IMG } from '../../constants/imageConstants';

const SbMobileTileBoxComponent = ({
    titleMessage,
    imgSrc,
    className,
    urlMessage,
    intl,
    onClick = () => {},
}) => {
    const formattedTitleMessage = intl.formatMessage(titleMessage);
    const formattedUrlMessage = intl.formatMessage(urlMessage);

    return (
        <a
            href={formattedUrlMessage}
            className={`${styles.box} ${className}`}
            onClick={() => onClick(titleMessage.defaultMessage)}
        >
            <span className={styles.title}>{formattedTitleMessage}</span>
            <LazyImage
                offsetVertical={VERTICAL_OFFSET_MOBILE_IMG}
                placeholderClass={styles.placeholder}
            >
                <img src={imgSrc} className={styles.image} alt={formattedTitleMessage} />
            </LazyImage>
        </a>
    );
};

SbMobileTileBoxComponent.propTypes = {
    titleMessage: PropTypes.object.isRequired,
    imgSrc: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    urlMessage: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    onClick: PropTypes.func,
};

export const SbMobileTileBox = injectIntl(SbMobileTileBoxComponent);
